import React from 'react';
var OS;
(function (OS) {
    OS[OS["MAC"] = 0] = "MAC";
    OS[OS["IOS"] = 1] = "IOS";
    OS[OS["WINDOWS"] = 2] = "WINDOWS";
    OS[OS["ANDROID"] = 3] = "ANDROID";
    OS[OS["LINUX"] = 4] = "LINUX";
})(OS || (OS = {}));
const isMobile = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
    }
    return false;
};
// https://stackoverflow.com/a/38241481
const getOperatingSystem = () => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    // default to Mac
    let os = OS.MAC;
    if (macosPlatforms.indexOf(platform) !== -1) {
        os = OS.MAC;
    }
    else if (iosPlatforms.indexOf(platform) !== -1) {
        os = OS.IOS;
    }
    else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = OS.WINDOWS;
    }
    else if (/Android/.test(userAgent)) {
        os = OS.ANDROID;
    }
    else if (!os && /Linux/.test(platform)) {
        os = OS.LINUX;
    }
    return os;
};
const getEventTrigger = (event) => {
    if ([OS.WINDOWS, OS.ANDROID, OS.LINUX].includes(getOperatingSystem())) {
        return event.ctrlKey;
    }
    else {
        return event.metaKey;
    }
};
const getTriggerKey = () => {
    if ([OS.WINDOWS, OS.ANDROID, OS.LINUX].includes(getOperatingSystem())) {
        return 'Ctrl';
    }
    else {
        return '⌘';
    }
};
const useOS = () => {
    const details = React.useMemo(() => {
        return {
            getEventTrigger: getEventTrigger,
            triggerKey: getTriggerKey(),
            os: getOperatingSystem(),
            isMobile: isMobile(),
        };
    }, []);
    return details;
};
export default useOS;
//# sourceMappingURL=data:application/json;base64,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